<form class="p-16" [formGroup]="form">
    <div class="my-16" style="width: 99%;">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{"COMPLAINTS.DETAIL.CRITICALITY" | translate}}</mat-label>
            <mat-select class="p-8" formControlName="criticalityTypeId">
                <mat-option *ngFor="let type of criticalityTypes" [value]="type.id">{{type.description}}</mat-option>
            </mat-select>
        </mat-form-field>
        <div class="p-4">
            <mat-error *ngIf="form.get('criticalityTypeId').hasError('required')">{{"errors.ErrAlertCriticalityIsRequired" | translate}}</mat-error>
        </div>
    </div>

    <div class="my-16" style="width: 99%;">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{"COMPLAINTS.DETAIL.ENTITY_ALERT_BELONGS" | translate}}</mat-label>
            <input matInput class="p-8" formControlName="entityAlertBelongs" maxlength="{{maxLength}}"/>
        </mat-form-field>
        <div style="width: 100%; display: flex; justify-content: space-between;"  class="p-4">
            <mat-error *ngIf="form.get('entityAlertBelongs').hasError('required')">{{"errors.ErrAlertEntityIsRequired" | translate}}</mat-error>
            <mat-error *ngIf="form.get('entityAlertBelongs').hasError('maxLength')">{{"errors.maxLengthExceded" | translate}}</mat-error>
            <div align="end">
                <mat-hint>{{entityInputLenght}} / {{maxLength}}</mat-hint>
            </div>
            
        </div>
    </div>
</form>
